<template>
  <div class="app" id="app">
      <router-view v-wechat-title="$route.meta.title" />
      <com-footer v-model="$route.meta.showFooter"></com-footer>
  </div>
</template>
<script>
import ComFooter from '@/components/footer'
export default {
  data () {
    return {
      isShoppingMall: true
    }
  },
  components: {
    ComFooter
  }
}
</script>
<style lang="stylus">
.app
  height 100vh
  background rgba(236,236,236,1)
</style>
